import { render, staticRenderFns } from "./appcontent.vue?vue&type=template&id=716b3ad2&scoped=true"
import script from "./appcontent.vue?vue&type=script&lang=js"
export * from "./appcontent.vue?vue&type=script&lang=js"
import style0 from "./appcontent.vue?vue&type=style&index=0&id=716b3ad2&prod&scoped=true&xmlns=http%3A%2F%2Fwww.w3.org%2F1999%2Fhtml&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "716b3ad2",
  null
  
)

export default component.exports